import React from "react";

import AccordionItem from "./AccordionItem";

import "./Accordion.scss";

const Accordion = ({ items, options, cssClass }) => {
  const defaultClassName = cssClass
    ? ["module module__accordion", cssClass].join(" ")
    : `module module__accordion`;

  // options = {
  //     titleHtmlTag,
  //     allowMultiple,
  //     scrollToTopOfAccordion
  // }

  return (
    <div className={defaultClassName}>
      <div className="module__box">
        <div className="accordion">
          {items.map((item, index) => {
            return (
              <AccordionItem
                title={item.title}
                id={item.id}
                content={item.content}
                index={index}
                options={options}
                key={index}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
